var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23223 5.73223C3.70107 5.26339 4.33696 5 5 5H9.16667C9.6269 5 10 5.3731 10 5.83333C10 6.29357 9.6269 6.66667 9.16667 6.66667H5C4.77899 6.66667 4.56702 6.75446 4.41074 6.91074C4.25446 7.06702 4.16667 7.27899 4.16667 7.5V15C4.16667 15.221 4.25446 15.433 4.41074 15.5893C4.56702 15.7455 4.77899 15.8333 5 15.8333H12.5C12.721 15.8333 12.933 15.7455 13.0893 15.5893C13.2455 15.433 13.3333 15.221 13.3333 15V10.8333C13.3333 10.3731 13.7064 10 14.1667 10C14.6269 10 15 10.3731 15 10.8333V15C15 15.663 14.7366 16.2989 14.2678 16.7678C13.7989 17.2366 13.163 17.5 12.5 17.5H5C4.33696 17.5 3.70107 17.2366 3.23223 16.7678C2.76339 16.2989 2.5 15.663 2.5 15V7.5C2.5 6.83696 2.76339 6.20107 3.23223 5.73223Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2559 2.74408C17.5814 3.06951 17.5814 3.59715 17.2559 3.92259L8.92259 12.2559C8.59715 12.5814 8.06951 12.5814 7.74408 12.2559C7.41864 11.9305 7.41864 11.4028 7.74408 11.0774L16.0774 2.74408C16.4028 2.41864 16.9305 2.41864 17.2559 2.74408Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 3.33333C11.6667 2.8731 12.0398 2.5 12.5 2.5H16.6667C17.1269 2.5 17.5 2.8731 17.5 3.33333V7.5C17.5 7.96024 17.1269 8.33333 16.6667 8.33333C16.2064 8.33333 15.8333 7.96024 15.8333 7.5V4.16667H12.5C12.0398 4.16667 11.6667 3.79357 11.6667 3.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/externalLink.46e9df0fa660481dc726160ab8cb642a.svg";
export { ForwardRef as ReactComponent };